
import { MaterialModule } from './material.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';

//import Aura from '@primeuix/themes/aura';
//import { providePrimeNG } from 'primeng/config';

import { providePrimeNG } from 'primeng/config';
import { VetorITPreset } from './theme/vetorit-preset';


import { routes } from './app.routes';
import { ConfirmationService, MessageService } from 'primeng/api';
import { primeNgPtBR } from './primeng-ptBR';
import { CookieService } from 'ngx-cookie-service';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);
export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        // withFetch() quebra downloads binários (PDF/Excel com responseType: 'blob').
        provideHttpClient(
          withInterceptors([tokenInterceptor])
        ),

        importProvidersFrom(MaterialModule),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: VetorITPreset,
                options: { darkModeSelector: '.app-dark' }
            }
        }),
        ConfirmationService,
        MessageService,
        CookieService,
        importProvidersFrom(DynamicDialogModule),
        DialogService,
        
    ]
};

